import { BuildingAmenity, UnitAmenity, UnitAmenityTag, ColumnValueOption } from './clients'
import { getAmenityTitle } from './utils'

export const allStates: ColumnValueOption[] = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'DC', label: 'District of Columbia' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' }
]

export const allMsas: ColumnValueOption[] = [
  {
    value: 'Flagstaff, AZ',
    label: 'Flagstaff, AZ'
  },
  {
    value: 'Portland-South Portland, ME',
    label: 'Portland-South Portland, ME'
  },
  {
    value: 'Lake Havasu City-Kingman, AZ',
    label: 'Lake Havasu City-Kingman, AZ'
  },
  {
    value: 'Sacramento-Roseville-Arden-Arcade, CA',
    label: 'Sacramento-Roseville-Arden-Arcade, CA'
  },
  {
    value: 'Sulphur Springs, TX',
    label: 'Sulphur Springs, TX'
  },
  {
    value: 'Washington Court House, OH',
    label: 'Washington Court House, OH'
  },
  {
    value: 'Mount Pleasant, MI',
    label: 'Mount Pleasant, MI'
  },
  {
    value: 'Sedalia, MO',
    label: 'Sedalia, MO'
  },
  {
    value: 'Levelland, TX',
    label: 'Levelland, TX'
  },
  {
    value: 'Atlantic City-Hammonton, NJ',
    label: 'Atlantic City-Hammonton, NJ'
  },
  {
    value: 'Owatonna, MN',
    label: 'Owatonna, MN'
  },
  {
    value: 'New York-Newark-Jersey City, NY-NJ-PA',
    label: 'New York-Newark-Jersey City, NY-NJ-PA'
  },
  {
    value: 'Dodge City, KS',
    label: 'Dodge City, KS'
  },
  {
    value: 'Tifton, GA',
    label: 'Tifton, GA'
  },
  {
    value: 'Chillicothe, OH',
    label: 'Chillicothe, OH'
  },
  {
    value: 'Mount Vernon, IL',
    label: 'Mount Vernon, IL'
  },
  {
    value: 'Battle Creek, MI',
    label: 'Battle Creek, MI'
  },
  {
    value: 'Owosso, MI',
    label: 'Owosso, MI'
  },
  {
    value: 'Elmira, NY',
    label: 'Elmira, NY'
  },
  {
    value: 'Grand Rapids-Wyoming, MI',
    label: 'Grand Rapids-Wyoming, MI'
  },
  {
    value: 'Kingston, NY',
    label: 'Kingston, NY'
  },
  {
    value: 'Moberly, MO',
    label: 'Moberly, MO'
  },
  {
    value: 'Wapakoneta, OH',
    label: 'Wapakoneta, OH'
  },
  {
    value: 'Atchison, KS',
    label: 'Atchison, KS'
  },
  {
    value: 'Wilson, NC',
    label: 'Wilson, NC'
  },
  {
    value: 'Beeville, TX',
    label: 'Beeville, TX'
  },
  {
    value: 'Mount Vernon, OH',
    label: 'Mount Vernon, OH'
  },
  {
    value: 'Brookings, SD',
    label: 'Brookings, SD'
  },
  {
    value: 'Bainbridge, GA',
    label: 'Bainbridge, GA'
  },
  {
    value: 'Fredericksburg, TX',
    label: 'Fredericksburg, TX'
  },
  {
    value: 'Toledo, OH',
    label: 'Toledo, OH'
  },
  {
    value: 'Deming, NM',
    label: 'Deming, NM'
  },
  {
    value: 'Torrington, CT',
    label: 'Torrington, CT'
  },
  {
    value: 'Guymon, OK',
    label: 'Guymon, OK'
  },
  {
    value: 'Tahlequah, OK',
    label: 'Tahlequah, OK'
  },
  {
    value: 'Jasper, IN',
    label: 'Jasper, IN'
  },
  {
    value: 'Douglas, GA',
    label: 'Douglas, GA'
  },
  {
    value: 'Gainesville, GA',
    label: 'Gainesville, GA'
  },
  {
    value: 'Bloomsburg-Berwick, PA',
    label: 'Bloomsburg-Berwick, PA'
  },
  {
    value: 'Shelby, NC',
    label: 'Shelby, NC'
  },
  {
    value: 'Adrian, MI',
    label: 'Adrian, MI'
  },
  {
    value: 'Brainerd, MN',
    label: 'Brainerd, MN'
  },
  {
    value: 'Liberal, KS',
    label: 'Liberal, KS'
  },
  {
    value: 'Kokomo, IN',
    label: 'Kokomo, IN'
  },
  {
    value: 'Lansing-East Lansing, MI',
    label: 'Lansing-East Lansing, MI'
  },
  {
    value: 'Seymour, IN',
    label: 'Seymour, IN'
  },
  {
    value: 'Cambridge, OH',
    label: 'Cambridge, OH'
  },
  {
    value: 'Iowa City, IA',
    label: 'Iowa City, IA'
  },
  {
    value: 'Cedartown, GA',
    label: 'Cedartown, GA'
  },
  {
    value: 'Alma, MI',
    label: 'Alma, MI'
  },
  {
    value: 'Boone, IA',
    label: 'Boone, IA'
  },
  {
    value: 'Kearney, NE',
    label: 'Kearney, NE'
  },
  {
    value: 'Angola, IN',
    label: 'Angola, IN'
  },
  {
    value: 'Kerrville, TX',
    label: 'Kerrville, TX'
  },
  {
    value: 'Cortland, NY',
    label: 'Cortland, NY'
  },
  {
    value: 'Hays, KS',
    label: 'Hays, KS'
  },
  {
    value: 'Fort Leonard Wood, MO',
    label: 'Fort Leonard Wood, MO'
  },
  {
    value: 'Peru, IN',
    label: 'Peru, IN'
  },
  {
    value: 'Merrill, WI',
    label: 'Merrill, WI'
  },
  {
    value: 'New Philadelphia-Dover, OH',
    label: 'New Philadelphia-Dover, OH'
  },
  {
    value: 'Dallas-Fort Worth-Arlington, TX',
    label: 'Dallas-Fort Worth-Arlington, TX'
  },
  {
    value: 'Hot Springs, AR',
    label: 'Hot Springs, AR'
  },
  {
    value: 'Redding, CA',
    label: 'Redding, CA'
  },
  {
    value: 'Sandusky, OH',
    label: 'Sandusky, OH'
  },
  {
    value: 'Hammond, LA',
    label: 'Hammond, LA'
  },
  {
    value: 'Hillsdale, MI',
    label: 'Hillsdale, MI'
  },
  {
    value: 'Charlotte-Concord-Gastonia, NC-SC',
    label: 'Charlotte-Concord-Gastonia, NC-SC'
  },
  {
    value: 'Whitewater-Elkhorn, WI',
    label: 'Whitewater-Elkhorn, WI'
  },
  {
    value: 'Ruston, LA',
    label: 'Ruston, LA'
  },
  {
    value: 'Sweetwater, TX',
    label: 'Sweetwater, TX'
  },
  {
    value: 'Crestview-Fort Walton Beach-Destin, FL',
    label: 'Crestview-Fort Walton Beach-Destin, FL'
  },
  {
    value: 'Prineville, OR',
    label: 'Prineville, OR'
  },
  {
    value: 'Thomaston, GA',
    label: 'Thomaston, GA'
  },
  {
    value: 'Sturgis, MI',
    label: 'Sturgis, MI'
  },
  {
    value: 'Craig, CO',
    label: 'Craig, CO'
  },
  {
    value: 'Galesburg, IL',
    label: 'Galesburg, IL'
  },
  {
    value: 'Wheeling, WV-OH',
    label: 'Wheeling, WV-OH'
  },
  {
    value: 'Paris, TN',
    label: 'Paris, TN'
  },
  {
    value: 'Port Clinton, OH',
    label: 'Port Clinton, OH'
  },
  {
    value: 'Brookhaven, MS',
    label: 'Brookhaven, MS'
  },
  {
    value: 'Truckee-Grass Valley, CA',
    label: 'Truckee-Grass Valley, CA'
  },
  {
    value: 'New Orleans-Metairie, LA',
    label: 'New Orleans-Metairie, LA'
  },
  {
    value: 'Forrest City, AR',
    label: 'Forrest City, AR'
  },
  {
    value: 'Dumas, TX',
    label: 'Dumas, TX'
  },
  {
    value: 'Fallon, NV',
    label: 'Fallon, NV'
  },
  {
    value: 'Marquette, MI',
    label: 'Marquette, MI'
  },
  {
    value: 'Menomonie, WI',
    label: 'Menomonie, WI'
  },
  {
    value: 'Midland, MI',
    label: 'Midland, MI'
  },
  {
    value: 'Lumberton, NC',
    label: 'Lumberton, NC'
  },
  {
    value: 'Medford, OR',
    label: 'Medford, OR'
  },
  {
    value: 'Longview, TX',
    label: 'Longview, TX'
  },
  {
    value: 'Seneca Falls, NY',
    label: 'Seneca Falls, NY'
  },
  {
    value: 'Santa Maria-Santa Barbara, CA',
    label: 'Santa Maria-Santa Barbara, CA'
  },
  {
    value: 'Jefferson City, MO',
    label: 'Jefferson City, MO'
  },
  {
    value: 'Springfield, OH',
    label: 'Springfield, OH'
  },
  {
    value: 'Amsterdam, NY',
    label: 'Amsterdam, NY'
  },
  {
    value: 'Pampa, TX',
    label: 'Pampa, TX'
  },
  {
    value: 'Nogales, AZ',
    label: 'Nogales, AZ'
  },
  {
    value: 'Beatrice, NE',
    label: 'Beatrice, NE'
  },
  {
    value: 'Athens, OH',
    label: 'Athens, OH'
  },
  {
    value: 'Sheboygan, WI',
    label: 'Sheboygan, WI'
  },
  {
    value: 'Coos Bay, OR',
    label: 'Coos Bay, OR'
  },
  {
    value: 'Glenwood Springs, CO',
    label: 'Glenwood Springs, CO'
  },
  {
    value: 'Norfolk, NE',
    label: 'Norfolk, NE'
  },
  {
    value: 'Aberdeen, SD',
    label: 'Aberdeen, SD'
  },
  {
    value: 'Miami, OK',
    label: 'Miami, OK'
  },
  {
    value: 'Raymondville, TX',
    label: 'Raymondville, TX'
  },
  {
    value: 'Muscatine, IA',
    label: 'Muscatine, IA'
  },
  {
    value: 'Farmington, MO',
    label: 'Farmington, MO'
  },
  {
    value: 'Jefferson, GA',
    label: 'Jefferson, GA'
  },
  {
    value: 'Marion, NC',
    label: 'Marion, NC'
  },
  {
    value: 'Muncie, IN',
    label: 'Muncie, IN'
  },
  {
    value: 'Crawfordsville, IN',
    label: 'Crawfordsville, IN'
  },
  {
    value: 'Arcadia, FL',
    label: 'Arcadia, FL'
  },
  {
    value: 'Zanesville, OH',
    label: 'Zanesville, OH'
  },
  {
    value: 'Ardmore, OK',
    label: 'Ardmore, OK'
  },
  {
    value: 'Oshkosh-Neenah, WI',
    label: 'Oshkosh-Neenah, WI'
  },
  {
    value: 'Boston-Cambridge-Newton, MA-NH',
    label: 'Boston-Cambridge-Newton, MA-NH'
  },
  {
    value: 'Huntington, IN',
    label: 'Huntington, IN'
  },
  {
    value: 'Mason City, IA',
    label: 'Mason City, IA'
  },
  {
    value: 'Faribault-Northfield, MN',
    label: 'Faribault-Northfield, MN'
  },
  {
    value: 'Odessa, TX',
    label: 'Odessa, TX'
  },
  {
    value: 'Appleton, WI',
    label: 'Appleton, WI'
  },
  {
    value: 'Hutchinson, KS',
    label: 'Hutchinson, KS'
  },
  {
    value: 'Bedford, IN',
    label: 'Bedford, IN'
  },
  {
    value: 'Lubbock, TX',
    label: 'Lubbock, TX'
  },
  {
    value: 'Ashtabula, OH',
    label: 'Ashtabula, OH'
  },
  {
    value: 'Jackson, OH',
    label: 'Jackson, OH'
  },
  {
    value: 'Wilmington, OH',
    label: 'Wilmington, OH'
  },
  {
    value: 'Rome, GA',
    label: 'Rome, GA'
  },
  {
    value: 'Evanston, WY',
    label: 'Evanston, WY'
  },
  {
    value: 'Uvalde, TX',
    label: 'Uvalde, TX'
  },
  {
    value: 'Warrensburg, MO',
    label: 'Warrensburg, MO'
  },
  {
    value: 'Emporia, KS',
    label: 'Emporia, KS'
  },
  {
    value: 'Spearfish, SD',
    label: 'Spearfish, SD'
  },
  {
    value: 'Plymouth, IN',
    label: 'Plymouth, IN'
  },
  {
    value: 'Minot, ND',
    label: 'Minot, ND'
  },
  {
    value: 'Montrose, CO',
    label: 'Montrose, CO'
  },
  {
    value: 'Jamestown, ND',
    label: 'Jamestown, ND'
  },
  {
    value: 'Rock Springs, WY',
    label: 'Rock Springs, WY'
  },
  {
    value: 'Carlsbad-Artesia, NM',
    label: 'Carlsbad-Artesia, NM'
  },
  {
    value: 'Indianola, MS',
    label: 'Indianola, MS'
  },
  {
    value: 'Canton-Massillon, OH',
    label: 'Canton-Massillon, OH'
  },
  {
    value: 'Sierra Vista-Douglas, AZ',
    label: 'Sierra Vista-Douglas, AZ'
  },
  {
    value: 'Hutchinson, MN',
    label: 'Hutchinson, MN'
  },
  {
    value: 'Glasgow, KY',
    label: 'Glasgow, KY'
  },
  {
    value: 'Othello, WA',
    label: 'Othello, WA'
  },
  {
    value: 'Amarillo, TX',
    label: 'Amarillo, TX'
  },
  {
    value: 'Laurel, MS',
    label: 'Laurel, MS'
  },
  {
    value: 'Corning, NY',
    label: 'Corning, NY'
  },
  {
    value: 'Alice, TX',
    label: 'Alice, TX'
  },
  {
    value: 'Calhoun, GA',
    label: 'Calhoun, GA'
  },
  {
    value: 'Meridian, MS',
    label: 'Meridian, MS'
  },
  {
    value: 'Stephenville, TX',
    label: 'Stephenville, TX'
  },
  {
    value: 'Mansfield, OH',
    label: 'Mansfield, OH'
  },
  {
    value: 'Dalton, GA',
    label: 'Dalton, GA'
  },
  {
    value: 'Hattiesburg, MS',
    label: 'Hattiesburg, MS'
  },
  {
    value: 'Texarkana, TX-AR',
    label: 'Texarkana, TX-AR'
  },
  {
    value: 'Fairfield, IA',
    label: 'Fairfield, IA'
  },
  {
    value: 'Twin Falls, ID',
    label: 'Twin Falls, ID'
  },
  {
    value: 'Greensburg, IN',
    label: 'Greensburg, IN'
  },
  {
    value: 'Santa Isabel, PR',
    label: 'Santa Isabel, PR'
  },
  {
    value: 'Willmar, MN',
    label: 'Willmar, MN'
  },
  {
    value: 'Huron, SD',
    label: 'Huron, SD'
  },
  {
    value: 'North Wilkesboro, NC',
    label: 'North Wilkesboro, NC'
  },
  {
    value: 'Bartlesville, OK',
    label: 'Bartlesville, OK'
  },
  {
    value: 'Andrews, TX',
    label: 'Andrews, TX'
  },
  {
    value: 'Macomb, IL',
    label: 'Macomb, IL'
  },
  {
    value: 'Bradford, PA',
    label: 'Bradford, PA'
  },
  {
    value: 'Decatur, IN',
    label: 'Decatur, IN'
  },
  {
    value: 'Enid, OK',
    label: 'Enid, OK'
  },
  {
    value: 'Mountain Home, ID',
    label: 'Mountain Home, ID'
  },
  {
    value: 'Van Wert, OH',
    label: 'Van Wert, OH'
  },
  {
    value: 'Kankakee, IL',
    label: 'Kankakee, IL'
  },
  {
    value: 'Mayfield, KY',
    label: 'Mayfield, KY'
  },
  {
    value: 'Greenville-Anderson-Mauldin, SC',
    label: 'Greenville-Anderson-Mauldin, SC'
  },
  {
    value: 'Fond du Lac, WI',
    label: 'Fond du Lac, WI'
  },
  {
    value: 'Cordele, GA',
    label: 'Cordele, GA'
  },
  {
    value: 'Storm Lake, IA',
    label: 'Storm Lake, IA'
  },
  {
    value: 'Bloomington, IN',
    label: 'Bloomington, IN'
  },
  {
    value: 'El Paso, TX',
    label: 'El Paso, TX'
  },
  {
    value: 'Austin, MN',
    label: 'Austin, MN'
  },
  {
    value: 'Wausau, WI',
    label: 'Wausau, WI'
  },
  {
    value: 'Cadillac, MI',
    label: 'Cadillac, MI'
  },
  {
    value: 'Abilene, TX',
    label: 'Abilene, TX'
  },
  {
    value: 'Rochelle, IL',
    label: 'Rochelle, IL'
  },
  {
    value: 'Sayre, PA',
    label: 'Sayre, PA'
  },
  {
    value: 'Newton, IA',
    label: 'Newton, IA'
  },
  {
    value: 'Mexico, MO',
    label: 'Mexico, MO'
  },
  {
    value: 'Connersville, IN',
    label: 'Connersville, IN'
  },
  {
    value: 'Oil City, PA',
    label: 'Oil City, PA'
  },
  {
    value: 'Henderson, NC',
    label: 'Henderson, NC'
  },
  {
    value: 'Enterprise, AL',
    label: 'Enterprise, AL'
  },
  {
    value: 'Rolla, MO',
    label: 'Rolla, MO'
  },
  {
    value: 'Burlington, NC',
    label: 'Burlington, NC'
  },
  {
    value: 'Marshall, MN',
    label: 'Marshall, MN'
  },
  {
    value: 'Jacksonville, IL',
    label: 'Jacksonville, IL'
  },
  {
    value: 'Dothan, AL',
    label: 'Dothan, AL'
  },
  {
    value: 'Spencer, IA',
    label: 'Spencer, IA'
  },
  {
    value: 'Savannah, GA',
    label: 'Savannah, GA'
  },
  {
    value: 'Centralia, IL',
    label: 'Centralia, IL'
  },
  {
    value: 'Fremont, OH',
    label: 'Fremont, OH'
  },
  {
    value: 'Mineral Wells, TX',
    label: 'Mineral Wells, TX'
  },
  {
    value: 'Lincoln, NE',
    label: 'Lincoln, NE'
  },
  {
    value: 'Warren, PA',
    label: 'Warren, PA'
  },
  {
    value: 'Gettysburg, PA',
    label: 'Gettysburg, PA'
  },
  {
    value: 'Grenada, MS',
    label: 'Grenada, MS'
  },
  {
    value: 'Lincoln, IL',
    label: 'Lincoln, IL'
  },
  {
    value: 'Borger, TX',
    label: 'Borger, TX'
  },
  {
    value: 'Alexandria, MN',
    label: 'Alexandria, MN'
  },
  {
    value: 'Maryville, MO',
    label: 'Maryville, MO'
  },
  {
    value: 'Dayton, OH',
    label: 'Dayton, OH'
  },
  {
    value: 'Parsons, KS',
    label: 'Parsons, KS'
  },
  {
    value: 'Colorado Springs, CO',
    label: 'Colorado Springs, CO'
  },
  {
    value: 'Brookings, OR',
    label: 'Brookings, OR'
  },
  {
    value: 'Norwalk, OH',
    label: 'Norwalk, OH'
  },
  {
    value: 'Lewiston-Auburn, ME',
    label: 'Lewiston-Auburn, ME'
  },
  {
    value: 'San Luis Obispo-Paso Robles-Arroyo Grande, CA',
    label: 'San Luis Obispo-Paso Robles-Arroyo Grande, CA'
  },
  {
    value: 'Celina, OH',
    label: 'Celina, OH'
  },
  {
    value: 'Augusta-Richmond County, GA-SC',
    label: 'Augusta-Richmond County, GA-SC'
  },
  {
    value: 'Arecibo, PR',
    label: 'Arecibo, PR'
  },
  {
    value: 'Akron, OH',
    label: 'Akron, OH'
  },
  {
    value: 'Wabash, IN',
    label: 'Wabash, IN'
  },
  {
    value: 'Virginia Beach-Norfolk-Newport News, VA-NC',
    label: 'Virginia Beach-Norfolk-Newport News, VA-NC'
  },
  {
    value: 'Pueblo, CO',
    label: 'Pueblo, CO'
  },
  {
    value: 'Huntington-Ashland, WV-KY-OH',
    label: 'Huntington-Ashland, WV-KY-OH'
  },
  {
    value: 'Corinth, MS',
    label: 'Corinth, MS'
  },
  {
    value: 'Jayuya, PR',
    label: 'Jayuya, PR'
  },
  {
    value: 'Show Low, AZ',
    label: 'Show Low, AZ'
  },
  {
    value: 'Washington-Arlington-Alexandria, DC-VA-MD-WV',
    label: 'Washington-Arlington-Alexandria, DC-VA-MD-WV'
  },
  {
    value: 'Adjuntas, PR',
    label: 'Adjuntas, PR'
  },
  {
    value: 'Boise City, ID',
    label: 'Boise City, ID'
  },
  {
    value: 'Little Rock-North Little Rock-Conway, AR',
    label: 'Little Rock-North Little Rock-Conway, AR'
  },
  {
    value: 'Lawrence, KS',
    label: 'Lawrence, KS'
  },
  {
    value: 'Johnstown, PA',
    label: 'Johnstown, PA'
  },
  {
    value: 'Elkhart-Goshen, IN',
    label: 'Elkhart-Goshen, IN'
  },
  {
    value: 'North Platte, NE',
    label: 'North Platte, NE'
  },
  {
    value: 'Eau Claire, WI',
    label: 'Eau Claire, WI'
  },
  {
    value: 'Las Vegas, NM',
    label: 'Las Vegas, NM'
  },
  {
    value: 'Goldsboro, NC',
    label: 'Goldsboro, NC'
  },
  {
    value: 'Hereford, TX',
    label: 'Hereford, TX'
  },
  {
    value: 'Guayama, PR',
    label: 'Guayama, PR'
  },
  {
    value: 'Sidney, OH',
    label: 'Sidney, OH'
  },
  {
    value: 'Richmond, VA',
    label: 'Richmond, VA'
  },
  {
    value: 'Blackfoot, ID',
    label: 'Blackfoot, ID'
  },
  {
    value: 'Starkville, MS',
    label: 'Starkville, MS'
  },
  {
    value: 'Weatherford, OK',
    label: 'Weatherford, OK'
  },
  {
    value: 'Helena, MT',
    label: 'Helena, MT'
  },
  {
    value: 'Des Moines-West Des Moines, IA',
    label: 'Des Moines-West Des Moines, IA'
  },
  {
    value: 'Ottawa-Peru, IL',
    label: 'Ottawa-Peru, IL'
  },
  {
    value: 'Marion, OH',
    label: 'Marion, OH'
  },
  {
    value: 'Kendallville, IN',
    label: 'Kendallville, IN'
  },
  {
    value: 'Asheville, NC',
    label: 'Asheville, NC'
  },
  {
    value: 'Waco, TX',
    label: 'Waco, TX'
  },
  {
    value: 'Kalamazoo-Portage, MI',
    label: 'Kalamazoo-Portage, MI'
  },
  {
    value: 'Cheyenne, WY',
    label: 'Cheyenne, WY'
  },
  {
    value: 'Findlay, OH',
    label: 'Findlay, OH'
  },
  {
    value: 'Auburn, IN',
    label: 'Auburn, IN'
  },
  {
    value: 'Barre, VT',
    label: 'Barre, VT'
  },
  {
    value: 'Fort Dodge, IA',
    label: 'Fort Dodge, IA'
  },
  {
    value: 'Lebanon, MO',
    label: 'Lebanon, MO'
  },
  {
    value: 'Cullman, AL',
    label: 'Cullman, AL'
  },
  {
    value: 'San Francisco-Oakland-Hayward, CA',
    label: 'San Francisco-Oakland-Hayward, CA'
  },
  {
    value: 'Hudson, NY',
    label: 'Hudson, NY'
  },
  {
    value: 'Ames, IA',
    label: 'Ames, IA'
  },
  {
    value: 'Jacksonville, FL',
    label: 'Jacksonville, FL'
  },
  {
    value: 'Ottawa, KS',
    label: 'Ottawa, KS'
  },
  {
    value: 'Bucyrus, OH',
    label: 'Bucyrus, OH'
  },
  {
    value: 'Warsaw, IN',
    label: 'Warsaw, IN'
  },
  {
    value: 'Saginaw, MI',
    label: 'Saginaw, MI'
  },
  {
    value: 'Snyder, TX',
    label: 'Snyder, TX'
  },
  {
    value: 'Salem, OR',
    label: 'Salem, OR'
  },
  {
    value: 'Dixon, IL',
    label: 'Dixon, IL'
  },
  {
    value: 'Dickinson, ND',
    label: 'Dickinson, ND'
  },
  {
    value: 'Urbana, OH',
    label: 'Urbana, OH'
  },
  {
    value: 'Garden City, KS',
    label: 'Garden City, KS'
  },
  {
    value: 'Salinas, CA',
    label: 'Salinas, CA'
  },
  {
    value: 'Vicksburg, MS',
    label: 'Vicksburg, MS'
  },
  {
    value: 'Woodward, OK',
    label: 'Woodward, OK'
  },
  {
    value: 'Wauchula, FL',
    label: 'Wauchula, FL'
  },
  {
    value: 'Summerville, GA',
    label: 'Summerville, GA'
  },
  {
    value: 'Albany, OR',
    label: 'Albany, OR'
  },
  {
    value: 'Coamo, PR',
    label: 'Coamo, PR'
  },
  {
    value: 'Junction City, KS',
    label: 'Junction City, KS'
  },
  {
    value: 'Mitchell, SD',
    label: 'Mitchell, SD'
  },
  {
    value: 'Providence-Warwick, RI-MA',
    label: 'Providence-Warwick, RI-MA'
  },
  {
    value: 'Pinehurst-Southern Pines, NC',
    label: 'Pinehurst-Southern Pines, NC'
  },
  {
    value: 'Greenville, OH',
    label: 'Greenville, OH'
  },
  {
    value: 'Columbus, NE',
    label: 'Columbus, NE'
  },
  {
    value: 'Oskaloosa, IA',
    label: 'Oskaloosa, IA'
  },
  {
    value: 'Tupelo, MS',
    label: 'Tupelo, MS'
  },
  {
    value: 'Marion, IN',
    label: 'Marion, IN'
  },
  {
    value: 'Watertown, SD',
    label: 'Watertown, SD'
  },
  {
    value: 'Pittsburg, KS',
    label: 'Pittsburg, KS'
  },
  {
    value: 'Magnolia, AR',
    label: 'Magnolia, AR'
  },
  {
    value: 'San Jose-Sunnyvale-Santa Clara, CA',
    label: 'San Jose-Sunnyvale-Santa Clara, CA'
  },
  {
    value: 'Fergus Falls, MN',
    label: 'Fergus Falls, MN'
  },
  {
    value: 'Summit Park, UT',
    label: 'Summit Park, UT'
  },
  {
    value: 'Flint, MI',
    label: 'Flint, MI'
  },
  {
    value: 'Big Spring, TX',
    label: 'Big Spring, TX'
  },
  {
    value: 'San Angelo, TX',
    label: 'San Angelo, TX'
  },
  {
    value: 'Wenatchee, WA',
    label: 'Wenatchee, WA'
  },
  {
    value: 'Midland, TX',
    label: 'Midland, TX'
  },
  {
    value: 'Fresno, CA',
    label: 'Fresno, CA'
  },
  {
    value: 'Red Bluff, CA',
    label: 'Red Bluff, CA'
  },
  {
    value: 'Ionia, MI',
    label: 'Ionia, MI'
  },
  {
    value: 'Watertown-Fort Atkinson, WI',
    label: 'Watertown-Fort Atkinson, WI'
  },
  {
    value: 'Lebanon, PA',
    label: 'Lebanon, PA'
  },
  {
    value: 'Grants Pass, OR',
    label: 'Grants Pass, OR'
  },
  {
    value: 'Somerset, PA',
    label: 'Somerset, PA'
  },
  {
    value: 'Corsicana, TX',
    label: 'Corsicana, TX'
  },
  {
    value: 'Ocala, FL',
    label: 'Ocala, FL'
  },
  {
    value: 'West Plains, MO',
    label: 'West Plains, MO'
  },
  {
    value: 'Great Bend, KS',
    label: 'Great Bend, KS'
  },
  {
    value: 'Springfield, MO',
    label: 'Springfield, MO'
  },
  {
    value: 'Martin, TN',
    label: 'Martin, TN'
  },
  {
    value: 'Coshocton, OH',
    label: 'Coshocton, OH'
  },
  {
    value: 'Sebastian-Vero Beach, FL',
    label: 'Sebastian-Vero Beach, FL'
  },
  {
    value: 'Payson, AZ',
    label: 'Payson, AZ'
  },
  {
    value: 'Big Rapids, MI',
    label: 'Big Rapids, MI'
  },
  {
    value: 'Marshalltown, IA',
    label: 'Marshalltown, IA'
  },
  {
    value: 'Shawano, WI',
    label: 'Shawano, WI'
  },
  {
    value: 'Duncan, OK',
    label: 'Duncan, OK'
  },
  {
    value: 'Kahului-Wailuku-Lahaina, HI',
    label: 'Kahului-Wailuku-Lahaina, HI'
  },
  {
    value: 'Mountain Home, AR',
    label: 'Mountain Home, AR'
  },
  {
    value: 'Ozark, AL',
    label: 'Ozark, AL'
  },
  {
    value: 'Ann Arbor, MI',
    label: 'Ann Arbor, MI'
  },
  {
    value: 'The Dalles, OR',
    label: 'The Dalles, OR'
  },
  {
    value: 'Defiance, OH',
    label: 'Defiance, OH'
  },
  {
    value: 'Fort Morgan, CO',
    label: 'Fort Morgan, CO'
  },
  {
    value: 'Lewistown, PA',
    label: 'Lewistown, PA'
  },
  {
    value: 'Logansport, IN',
    label: 'Logansport, IN'
  },
  {
    value: 'Knoxville, TN',
    label: 'Knoxville, TN'
  },
  {
    value: 'San Antonio-New Braunfels, TX',
    label: 'San Antonio-New Braunfels, TX'
  },
  {
    value: 'Indianapolis-Carmel-Anderson, IN',
    label: 'Indianapolis-Carmel-Anderson, IN'
  },
  {
    value: 'Coldwater, MI',
    label: 'Coldwater, MI'
  },
  {
    value: 'Cedar Rapids, IA',
    label: 'Cedar Rapids, IA'
  },
  {
    value: 'Greenwood, MS',
    label: 'Greenwood, MS'
  },
  {
    value: 'Columbus, IN',
    label: 'Columbus, IN'
  },
  {
    value: 'Bellefontaine, OH',
    label: 'Bellefontaine, OH'
  },
  {
    value: 'Memphis, TN-MS-AR',
    label: 'Memphis, TN-MS-AR'
  },
  {
    value: 'Muskogee, OK',
    label: 'Muskogee, OK'
  },
  {
    value: 'Champaign-Urbana, IL',
    label: 'Champaign-Urbana, IL'
  },
  {
    value: 'Baltimore-Columbia-Towson, MD',
    label: 'Baltimore-Columbia-Towson, MD'
  },
  {
    value: 'Clewiston, FL',
    label: 'Clewiston, FL'
  },
  {
    value: 'Effingham, IL',
    label: 'Effingham, IL'
  },
  {
    value: 'Moscow, ID',
    label: 'Moscow, ID'
  },
  {
    value: 'Sebring, FL',
    label: 'Sebring, FL'
  },
  {
    value: 'McPherson, KS',
    label: 'McPherson, KS'
  },
  {
    value: 'Philadelphia-Camden-Wilmington, PA-NJ-DE-MD',
    label: 'Philadelphia-Camden-Wilmington, PA-NJ-DE-MD'
  },
  {
    value: 'Peoria, IL',
    label: 'Peoria, IL'
  },
  {
    value: 'Wooster, OH',
    label: 'Wooster, OH'
  },
  {
    value: 'Kalispell, MT',
    label: 'Kalispell, MT'
  },
  {
    value: 'Houston-The Woodlands-Sugar Land, TX',
    label: 'Houston-The Woodlands-Sugar Land, TX'
  },
  {
    value: 'Sonora, CA',
    label: 'Sonora, CA'
  },
  {
    value: 'Scranton-Wilkes-Barre-Hazleton, PA',
    label: 'Scranton-Wilkes-Barre-Hazleton, PA'
  },
  {
    value: 'Centralia, WA',
    label: 'Centralia, WA'
  },
  {
    value: 'Ludington, MI',
    label: 'Ludington, MI'
  },
  {
    value: 'Altoona, PA',
    label: 'Altoona, PA'
  },
  {
    value: 'Fort Wayne, IN',
    label: 'Fort Wayne, IN'
  },
  {
    value: 'Riverside-San Bernardino-Ontario, CA',
    label: 'Riverside-San Bernardino-Ontario, CA'
  },
  {
    value: 'Daphne-Fairhope-Foley, AL',
    label: 'Daphne-Fairhope-Foley, AL'
  },
  {
    value: 'Lamesa, TX',
    label: 'Lamesa, TX'
  },
  {
    value: 'Lexington, NE',
    label: 'Lexington, NE'
  },
  {
    value: 'Dunn, NC',
    label: 'Dunn, NC'
  },
  {
    value: 'Pensacola-Ferry Pass-Brent, FL',
    label: 'Pensacola-Ferry Pass-Brent, FL'
  },
  {
    value: 'Concord, NH',
    label: 'Concord, NH'
  },
  {
    value: 'Rockford, IL',
    label: 'Rockford, IL'
  },
  {
    value: 'Lexington-Fayette, KY',
    label: 'Lexington-Fayette, KY'
  },
  {
    value: 'Worthington, MN',
    label: 'Worthington, MN'
  },
  {
    value: 'Albertville, AL',
    label: 'Albertville, AL'
  },
  {
    value: 'Madison, IN',
    label: 'Madison, IN'
  },
  {
    value: 'Berlin, NH-VT',
    label: 'Berlin, NH-VT'
  },
  {
    value: 'Stevens Point, WI',
    label: 'Stevens Point, WI'
  },
  {
    value: 'Columbus, GA-AL',
    label: 'Columbus, GA-AL'
  },
  {
    value: 'Decatur, IL',
    label: 'Decatur, IL'
  },
  {
    value: 'Troy, AL',
    label: 'Troy, AL'
  },
  {
    value: 'Pontiac, IL',
    label: 'Pontiac, IL'
  },
  {
    value: 'Beaver Dam, WI',
    label: 'Beaver Dam, WI'
  },
  {
    value: 'Billings, MT',
    label: 'Billings, MT'
  },
  {
    value: 'Seattle-Tacoma-Bellevue, WA',
    label: 'Seattle-Tacoma-Bellevue, WA'
  },
  {
    value: 'Ketchikan, AK',
    label: 'Ketchikan, AK'
  },
  {
    value: 'Mayagüez, PR',
    label: 'Mayagüez, PR'
  },
  {
    value: 'Scottsboro, AL',
    label: 'Scottsboro, AL'
  },
  {
    value: 'Oxford, NC',
    label: 'Oxford, NC'
  },
  {
    value: 'Plainview, TX',
    label: 'Plainview, TX'
  },
  {
    value: 'Lima, OH',
    label: 'Lima, OH'
  },
  {
    value: 'Baraboo, WI',
    label: 'Baraboo, WI'
  },
  {
    value: 'Ada, OK',
    label: 'Ada, OK'
  },
  {
    value: 'Los Alamos, NM',
    label: 'Los Alamos, NM'
  },
  {
    value: 'Cleveland-Elyria, OH',
    label: 'Cleveland-Elyria, OH'
  },
  {
    value: 'Alamogordo, NM',
    label: 'Alamogordo, NM'
  },
  {
    value: 'Pittsburgh, PA',
    label: 'Pittsburgh, PA'
  },
  {
    value: 'Alpena, MI',
    label: 'Alpena, MI'
  },
  {
    value: 'San Germán, PR',
    label: 'San Germán, PR'
  },
  {
    value: 'New Castle, PA',
    label: 'New Castle, PA'
  },
  {
    value: 'Albemarle, NC',
    label: 'Albemarle, NC'
  },
  {
    value: 'Murray, KY',
    label: 'Murray, KY'
  },
  {
    value: 'Port Lavaca, TX',
    label: 'Port Lavaca, TX'
  },
  {
    value: 'Jackson, TN',
    label: 'Jackson, TN'
  },
  {
    value: 'Wichita Falls, TX',
    label: 'Wichita Falls, TX'
  },
  {
    value: 'Canton, IL',
    label: 'Canton, IL'
  },
  {
    value: 'Beaumont-Port Arthur, TX',
    label: 'Beaumont-Port Arthur, TX'
  },
  {
    value: 'Sioux City, IA-NE-SD',
    label: 'Sioux City, IA-NE-SD'
  },
  {
    value: 'Columbus, MS',
    label: 'Columbus, MS'
  },
  {
    value: 'Cedar City, UT',
    label: 'Cedar City, UT'
  },
  {
    value: 'Harrisburg-Carlisle, PA',
    label: 'Harrisburg-Carlisle, PA'
  },
  {
    value: 'Lynchburg, VA',
    label: 'Lynchburg, VA'
  },
  {
    value: 'Pine Bluff, AR',
    label: 'Pine Bluff, AR'
  },
  {
    value: 'Gardnerville Ranchos, NV',
    label: 'Gardnerville Ranchos, NV'
  },
  {
    value: 'Phoenix-Mesa-Scottsdale, AZ',
    label: 'Phoenix-Mesa-Scottsdale, AZ'
  },
  {
    value: 'Homosassa Springs, FL',
    label: 'Homosassa Springs, FL'
  },
  {
    value: 'Santa Rosa, CA',
    label: 'Santa Rosa, CA'
  },
  {
    value: 'Tulsa, OK',
    label: 'Tulsa, OK'
  },
  {
    value: 'Pecos, TX',
    label: 'Pecos, TX'
  },
  {
    value: 'Coco, PR',
    label: 'Coco, PR'
  },
  {
    value: 'Michigan City-La Porte, IN',
    label: 'Michigan City-La Porte, IN'
  },
  {
    value: 'Thomasville, GA',
    label: 'Thomasville, GA'
  },
  {
    value: 'Crossville, TN',
    label: 'Crossville, TN'
  },
  {
    value: 'Hailey, ID',
    label: 'Hailey, ID'
  },
  {
    value: 'Cornelia, GA',
    label: 'Cornelia, GA'
  },
  {
    value: 'Brownwood, TX',
    label: 'Brownwood, TX'
  },
  {
    value: 'Charleston-North Charleston, SC',
    label: 'Charleston-North Charleston, SC'
  },
  {
    value: 'Sunbury, PA',
    label: 'Sunbury, PA'
  },
  {
    value: 'Ogden-Clearfield, UT',
    label: 'Ogden-Clearfield, UT'
  },
  {
    value: 'Manhattan, KS',
    label: 'Manhattan, KS'
  },
  {
    value: 'North Port-Sarasota-Bradenton, FL',
    label: 'North Port-Sarasota-Bradenton, FL'
  },
  {
    value: 'Sherman-Denison, TX',
    label: 'Sherman-Denison, TX'
  },
  {
    value: 'Portsmouth, OH',
    label: 'Portsmouth, OH'
  },
  {
    value: 'Frankfort, IN',
    label: 'Frankfort, IN'
  },
  {
    value: 'Miami-Fort Lauderdale-West Palm Beach, FL',
    label: 'Miami-Fort Lauderdale-West Palm Beach, FL'
  },
  {
    value: 'Gainesville, FL',
    label: 'Gainesville, FL'
  },
  {
    value: 'Greenville, MS',
    label: 'Greenville, MS'
  },
  {
    value: 'Barnstable Town, MA',
    label: 'Barnstable Town, MA'
  },
  {
    value: 'Charleston-Mattoon, IL',
    label: 'Charleston-Mattoon, IL'
  },
  {
    value: 'Richmond, IN',
    label: 'Richmond, IN'
  },
  {
    value: 'Baton Rouge, LA',
    label: 'Baton Rouge, LA'
  },
  {
    value: 'Sandpoint, ID',
    label: 'Sandpoint, ID'
  },
  {
    value: 'Jackson, MI',
    label: 'Jackson, MI'
  },
  {
    value: 'St. Marys, GA',
    label: 'St. Marys, GA'
  },
  {
    value: 'Harrison, AR',
    label: 'Harrison, AR'
  },
  {
    value: 'Taos, NM',
    label: 'Taos, NM'
  },
  {
    value: 'Pahrump, NV',
    label: 'Pahrump, NV'
  },
  {
    value: 'Ithaca, NY',
    label: 'Ithaca, NY'
  },
  {
    value: 'Dubuque, IA',
    label: 'Dubuque, IA'
  },
  {
    value: 'Milledgeville, GA',
    label: 'Milledgeville, GA'
  },
  {
    value: 'Albuquerque, NM',
    label: 'Albuquerque, NM'
  },
  {
    value: 'Tucson, AZ',
    label: 'Tucson, AZ'
  },
  {
    value: 'Richmond-Berea, KY',
    label: 'Richmond-Berea, KY'
  },
  {
    value: 'Grants, NM',
    label: 'Grants, NM'
  },
  {
    value: 'Talladega-Sylacauga, AL',
    label: 'Talladega-Sylacauga, AL'
  },
  {
    value: 'Glens Falls, NY',
    label: 'Glens Falls, NY'
  },
  {
    value: 'Reading, PA',
    label: 'Reading, PA'
  },
  {
    value: 'Kingsville, TX',
    label: 'Kingsville, TX'
  },
  {
    value: 'Fitzgerald, GA',
    label: 'Fitzgerald, GA'
  },
  {
    value: 'Boone, NC',
    label: 'Boone, NC'
  },
  {
    value: 'Plattsburgh, NY',
    label: 'Plattsburgh, NY'
  },
  {
    value: 'Pottsville, PA',
    label: 'Pottsville, PA'
  },
  {
    value: 'Mount Pleasant, TX',
    label: 'Mount Pleasant, TX'
  },
  {
    value: 'Camden, AR',
    label: 'Camden, AR'
  },
  {
    value: 'Cape Girardeau, MO-IL',
    label: 'Cape Girardeau, MO-IL'
  },
  {
    value: 'Blytheville, AR',
    label: 'Blytheville, AR'
  },
  {
    value: 'Huntsville, TX',
    label: 'Huntsville, TX'
  },
  {
    value: 'Madisonville, KY',
    label: 'Madisonville, KY'
  },
  {
    value: 'Jacksonville, NC',
    label: 'Jacksonville, NC'
  },
  {
    value: 'Fairmont, WV',
    label: 'Fairmont, WV'
  },
  {
    value: 'Somerset, KY',
    label: 'Somerset, KY'
  },
  {
    value: 'Prescott, AZ',
    label: 'Prescott, AZ'
  },
  {
    value: 'Natchitoches, LA',
    label: 'Natchitoches, LA'
  },
  {
    value: 'Laramie, WY',
    label: 'Laramie, WY'
  },
  {
    value: 'Gaffney, SC',
    label: 'Gaffney, SC'
  },
  {
    value: 'Hagerstown-Martinsburg, MD-WV',
    label: 'Hagerstown-Martinsburg, MD-WV'
  },
  {
    value: 'Vernal, UT',
    label: 'Vernal, UT'
  },
  {
    value: 'North Vernon, IN',
    label: 'North Vernon, IN'
  },
  {
    value: 'Longview, WA',
    label: 'Longview, WA'
  },
  {
    value: 'Greenfield Town, MA',
    label: 'Greenfield Town, MA'
  },
  {
    value: 'Elizabethtown-Fort Knox, KY',
    label: 'Elizabethtown-Fort Knox, KY'
  },
  {
    value: 'Bennington, VT',
    label: 'Bennington, VT'
  },
  {
    value: 'Monroe, MI',
    label: 'Monroe, MI'
  },
  {
    value: 'Vincennes, IN',
    label: 'Vincennes, IN'
  },
  {
    value: 'El Campo, TX',
    label: 'El Campo, TX'
  },
  {
    value: 'Statesboro, GA',
    label: 'Statesboro, GA'
  },
  {
    value: 'Hood River, OR',
    label: 'Hood River, OR'
  },
  {
    value: 'Selma, AL',
    label: 'Selma, AL'
  },
  {
    value: 'Casper, WY',
    label: 'Casper, WY'
  },
  {
    value: 'Waycross, GA',
    label: 'Waycross, GA'
  },
  {
    value: 'LaGrange, GA',
    label: 'LaGrange, GA'
  },
  {
    value: 'Augusta-Waterville, ME',
    label: 'Augusta-Waterville, ME'
  },
  {
    value: 'Chambersburg-Waynesboro, PA',
    label: 'Chambersburg-Waynesboro, PA'
  },
  {
    value: 'Eureka-Arcata-Fortuna, CA',
    label: 'Eureka-Arcata-Fortuna, CA'
  },
  {
    value: 'Sterling, CO',
    label: 'Sterling, CO'
  },
  {
    value: 'Easton, MD',
    label: 'Easton, MD'
  },
  {
    value: 'Spartanburg, SC',
    label: 'Spartanburg, SC'
  },
  {
    value: 'McComb, MS',
    label: 'McComb, MS'
  },
  {
    value: 'Steamboat Springs, CO',
    label: 'Steamboat Springs, CO'
  },
  {
    value: 'Sanford, NC',
    label: 'Sanford, NC'
  },
  {
    value: 'Malone, NY',
    label: 'Malone, NY'
  },
  {
    value: 'Chattanooga, TN-GA',
    label: 'Chattanooga, TN-GA'
  },
  {
    value: 'Brunswick, GA',
    label: 'Brunswick, GA'
  },
  {
    value: 'Springfield, MA',
    label: 'Springfield, MA'
  },
  {
    value: 'Salem, OH',
    label: 'Salem, OH'
  },
  {
    value: 'Hobbs, NM',
    label: 'Hobbs, NM'
  },
  {
    value: 'Santa Fe, NM',
    label: 'Santa Fe, NM'
  },
  {
    value: 'State College, PA',
    label: 'State College, PA'
  },
  {
    value: 'Frankfort, KY',
    label: 'Frankfort, KY'
  },
  {
    value: 'Morgan City, LA',
    label: 'Morgan City, LA'
  },
  {
    value: 'Platteville, WI',
    label: 'Platteville, WI'
  },
  {
    value: 'Dyersburg, TN',
    label: 'Dyersburg, TN'
  },
  {
    value: 'Escanaba, MI',
    label: 'Escanaba, MI'
  },
  {
    value: 'Meadville, PA',
    label: 'Meadville, PA'
  },
  {
    value: 'Georgetown, SC',
    label: 'Georgetown, SC'
  },
  {
    value: 'Mount Airy, NC',
    label: 'Mount Airy, NC'
  },
  {
    value: 'Palatka, FL',
    label: 'Palatka, FL'
  },
  {
    value: 'DuBois, PA',
    label: 'DuBois, PA'
  },
  {
    value: 'Boulder, CO',
    label: 'Boulder, CO'
  },
  {
    value: 'DeRidder, LA',
    label: 'DeRidder, LA'
  },
  {
    value: 'Punta Gorda, FL',
    label: 'Punta Gorda, FL'
  },
  {
    value: 'Tiffin, OH',
    label: 'Tiffin, OH'
  },
  {
    value: 'Pullman, WA',
    label: 'Pullman, WA'
  },
  {
    value: 'Muskegon, MI',
    label: 'Muskegon, MI'
  },
  {
    value: 'Shelton, WA',
    label: 'Shelton, WA'
  },
  {
    value: 'Scottsbluff, NE',
    label: 'Scottsbluff, NE'
  },
  {
    value: 'Missoula, MT',
    label: 'Missoula, MT'
  },
  {
    value: 'Racine, WI',
    label: 'Racine, WI'
  },
  {
    value: 'Roswell, NM',
    label: 'Roswell, NM'
  },
  {
    value: 'Mount Vernon-Anacortes, WA',
    label: 'Mount Vernon-Anacortes, WA'
  },
  {
    value: 'Lewisburg, PA',
    label: 'Lewisburg, PA'
  },
  {
    value: 'Laredo, TX',
    label: 'Laredo, TX'
  },
  {
    value: 'Lancaster, PA',
    label: 'Lancaster, PA'
  },
  {
    value: 'Brevard, NC',
    label: 'Brevard, NC'
  },
  {
    value: 'Bardstown, KY',
    label: 'Bardstown, KY'
  },
  {
    value: 'Manitowoc, WI',
    label: 'Manitowoc, WI'
  },
  {
    value: 'Sioux Falls, SD',
    label: 'Sioux Falls, SD'
  },
  {
    value: 'Silver City, NM',
    label: 'Silver City, NM'
  },
  {
    value: 'Roanoke, VA',
    label: 'Roanoke, VA'
  },
  {
    value: 'Winston-Salem, NC',
    label: 'Winston-Salem, NC'
  },
  {
    value: 'Fort Smith, AR-OK',
    label: 'Fort Smith, AR-OK'
  },
  {
    value: 'Wahpeton, ND-MN',
    label: 'Wahpeton, ND-MN'
  },
  {
    value: 'Portales, NM',
    label: 'Portales, NM'
  },
  {
    value: 'Chicago-Naperville-Elgin, IL-IN-WI',
    label: 'Chicago-Naperville-Elgin, IL-IN-WI'
  },
  {
    value: 'Pierre, SD',
    label: 'Pierre, SD'
  },
  {
    value: 'Atlanta-Sandy Springs-Roswell, GA',
    label: 'Atlanta-Sandy Springs-Roswell, GA'
  },
  {
    value: 'Dublin, GA',
    label: 'Dublin, GA'
  },
  {
    value: 'Bowling Green, KY',
    label: 'Bowling Green, KY'
  },
  {
    value: 'Idaho Falls, ID',
    label: 'Idaho Falls, ID'
  },
  {
    value: 'St. Joseph, MO-KS',
    label: 'St. Joseph, MO-KS'
  },
  {
    value: 'Albert Lea, MN',
    label: 'Albert Lea, MN'
  },
  {
    value: 'Clinton, IA',
    label: 'Clinton, IA'
  },
  {
    value: 'Tallahassee, FL',
    label: 'Tallahassee, FL'
  },
  {
    value: 'Lewiston, ID-WA',
    label: 'Lewiston, ID-WA'
  },
  {
    value: 'Albany, GA',
    label: 'Albany, GA'
  },
  {
    value: 'Deltona-Daytona Beach-Ormond Beach, FL',
    label: 'Deltona-Daytona Beach-Ormond Beach, FL'
  },
  {
    value: 'Laurinburg, NC',
    label: 'Laurinburg, NC'
  },
  {
    value: 'Hinesville, GA',
    label: 'Hinesville, GA'
  },
  {
    value: 'Rochester, MN',
    label: 'Rochester, MN'
  },
  {
    value: 'Burlington-South Burlington, VT',
    label: 'Burlington-South Burlington, VT'
  },
  {
    value: 'Hartford-West Hartford-East Hartford, CT',
    label: 'Hartford-West Hartford-East Hartford, CT'
  },
  {
    value: 'Olean, NY',
    label: 'Olean, NY'
  },
  {
    value: 'Dayton, TN',
    label: 'Dayton, TN'
  },
  {
    value: 'Tampa-St. Petersburg-Clearwater, FL',
    label: 'Tampa-St. Petersburg-Clearwater, FL'
  },
  {
    value: 'Riverton, WY',
    label: 'Riverton, WY'
  },
  {
    value: 'Traverse City, MI',
    label: 'Traverse City, MI'
  },
  {
    value: 'Cincinnati, OH-KY-IN',
    label: 'Cincinnati, OH-KY-IN'
  },
  {
    value: 'Hickory-Lenoir-Morganton, NC',
    label: 'Hickory-Lenoir-Morganton, NC'
  },
  {
    value: 'Salisbury, MD-DE',
    label: 'Salisbury, MD-DE'
  },
  {
    value: 'Yuma, AZ',
    label: 'Yuma, AZ'
  },
  {
    value: 'Clovis, NM',
    label: 'Clovis, NM'
  },
  {
    value: 'Logan, UT-ID',
    label: 'Logan, UT-ID'
  },
  {
    value: 'Grand Island, NE',
    label: 'Grand Island, NE'
  },
  {
    value: 'Vidalia, GA',
    label: 'Vidalia, GA'
  },
  {
    value: 'Minneapolis-St. Paul-Bloomington, MN-WI',
    label: 'Minneapolis-St. Paul-Bloomington, MN-WI'
  },
  {
    value: 'Lafayette-West Lafayette, IN',
    label: 'Lafayette-West Lafayette, IN'
  },
  {
    value: 'Killeen-Temple, TX',
    label: 'Killeen-Temple, TX'
  },
  {
    value: 'La Crosse-Onalaska, WI-MN',
    label: 'La Crosse-Onalaska, WI-MN'
  },
  {
    value: 'Albany-Schenectady-Troy, NY',
    label: 'Albany-Schenectady-Troy, NY'
  },
  {
    value: 'Greenwood, SC',
    label: 'Greenwood, SC'
  },
  {
    value: 'Sikeston, MO',
    label: 'Sikeston, MO'
  },
  {
    value: 'Austin-Round Rock, TX',
    label: 'Austin-Round Rock, TX'
  },
  {
    value: 'College Station-Bryan, TX',
    label: 'College Station-Bryan, TX'
  },
  {
    value: 'Raleigh, NC',
    label: 'Raleigh, NC'
  },
  {
    value: 'Orlando-Kissimmee-Sanford, FL',
    label: 'Orlando-Kissimmee-Sanford, FL'
  },
  {
    value: 'Charlottesville, VA',
    label: 'Charlottesville, VA'
  },
  {
    value: 'Nashville-Davidson-Murfreesboro-Franklin, TN',
    label: 'Nashville-Davidson-Murfreesboro-Franklin, TN'
  },
  {
    value: 'Omaha-Council Bluffs, NE-IA',
    label: 'Omaha-Council Bluffs, NE-IA'
  },
  {
    value: 'Staunton-Waynesboro, VA',
    label: 'Staunton-Waynesboro, VA'
  },
  {
    value: 'Detroit-Warren-Dearborn, MI',
    label: 'Detroit-Warren-Dearborn, MI'
  },
  {
    value: 'Clarksburg, WV',
    label: 'Clarksburg, WV'
  },
  {
    value: 'Urban Honolulu, HI',
    label: 'Urban Honolulu, HI'
  },
  {
    value: 'Lawton, OK',
    label: 'Lawton, OK'
  },
  {
    value: 'Paris, TX',
    label: 'Paris, TX'
  },
  {
    value: 'Joplin, MO',
    label: 'Joplin, MO'
  },
  {
    value: 'Lakeland-Winter Haven, FL',
    label: 'Lakeland-Winter Haven, FL'
  },
  {
    value: 'Oxnard-Thousand Oaks-Ventura, CA',
    label: 'Oxnard-Thousand Oaks-Ventura, CA'
  },
  {
    value: 'Taylorville, IL',
    label: 'Taylorville, IL'
  },
  {
    value: 'Norwich-New London, CT',
    label: 'Norwich-New London, CT'
  },
  {
    value: 'Alexandria, LA',
    label: 'Alexandria, LA'
  },
  {
    value: 'South Bend-Mishawaka, IN-MI',
    label: 'South Bend-Mishawaka, IN-MI'
  },
  {
    value: 'Okeechobee, FL',
    label: 'Okeechobee, FL'
  },
  {
    value: 'Mobile, AL',
    label: 'Mobile, AL'
  },
  {
    value: 'Indiana, PA',
    label: 'Indiana, PA'
  },
  {
    value: 'Maysville, KY',
    label: 'Maysville, KY'
  },
  {
    value: 'Corpus Christi, TX',
    label: 'Corpus Christi, TX'
  },
  {
    value: 'Cañon City, CO',
    label: 'Cañon City, CO'
  },
  {
    value: 'Lock Haven, PA',
    label: 'Lock Haven, PA'
  },
  {
    value: 'Cleveland, MS',
    label: 'Cleveland, MS'
  },
  {
    value: 'Kingsport-Bristol-Bristol, TN-VA',
    label: 'Kingsport-Bristol-Bristol, TN-VA'
  },
  {
    value: 'Ocean City, NJ',
    label: 'Ocean City, NJ'
  },
  {
    value: 'Mankato-North Mankato, MN',
    label: 'Mankato-North Mankato, MN'
  },
  {
    value: 'Marshall, TX',
    label: 'Marshall, TX'
  },
  {
    value: 'Bemidji, MN',
    label: 'Bemidji, MN'
  },
  {
    value: 'Yakima, WA',
    label: 'Yakima, WA'
  },
  {
    value: 'Cookeville, TN',
    label: 'Cookeville, TN'
  },
  {
    value: 'Holland, MI',
    label: 'Holland, MI'
  },
  {
    value: 'Worcester, MA-CT',
    label: 'Worcester, MA-CT'
  },
  {
    value: 'San Diego-Carlsbad, CA',
    label: 'San Diego-Carlsbad, CA'
  },
  {
    value: 'Macon, GA',
    label: 'Macon, GA'
  },
  {
    value: 'Topeka, KS',
    label: 'Topeka, KS'
  },
  {
    value: 'Red Wing, MN',
    label: 'Red Wing, MN'
  },
  {
    value: 'Elizabeth City, NC',
    label: 'Elizabeth City, NC'
  },
  {
    value: 'Jackson, WY-ID',
    label: 'Jackson, WY-ID'
  },
  {
    value: 'Athens-Clarke County, GA',
    label: 'Athens-Clarke County, GA'
  },
  {
    value: 'Keene, NH',
    label: 'Keene, NH'
  },
  {
    value: 'Birmingham-Hoover, AL',
    label: 'Birmingham-Hoover, AL'
  },
  {
    value: 'Cambridge, MD',
    label: 'Cambridge, MD'
  },
  {
    value: 'Wichita, KS',
    label: 'Wichita, KS'
  },
  {
    value: 'Newberry, SC',
    label: 'Newberry, SC'
  },
  {
    value: 'Poplar Bluff, MO',
    label: 'Poplar Bluff, MO'
  },
  {
    value: 'Jonesboro, AR',
    label: 'Jonesboro, AR'
  },
  {
    value: 'Logan, WV',
    label: 'Logan, WV'
  },
  {
    value: 'Parkersburg-Vienna, WV',
    label: 'Parkersburg-Vienna, WV'
  },
  {
    value: 'Green Bay, WI',
    label: 'Green Bay, WI'
  },
  {
    value: 'Great Falls, MT',
    label: 'Great Falls, MT'
  },
  {
    value: 'Las Cruces, NM',
    label: 'Las Cruces, NM'
  },
  {
    value: 'Ontario, OR-ID',
    label: 'Ontario, OR-ID'
  },
  {
    value: 'Kinston, NC',
    label: 'Kinston, NC'
  },
  {
    value: 'Port St. Lucie, FL',
    label: 'Port St. Lucie, FL'
  },
  {
    value: 'Vallejo-Fairfield, CA',
    label: 'Vallejo-Fairfield, CA'
  },
  {
    value: 'Americus, GA',
    label: 'Americus, GA'
  },
  {
    value: 'Freeport, IL',
    label: 'Freeport, IL'
  },
  {
    value: 'Danville, VA',
    label: 'Danville, VA'
  },
  {
    value: 'Hilton Head Island-Bluffton-Beaufort, SC',
    label: 'Hilton Head Island-Bluffton-Beaufort, SC'
  },
  {
    value: 'Walla Walla, WA',
    label: 'Walla Walla, WA'
  },
  {
    value: 'Burley, ID',
    label: 'Burley, ID'
  },
  {
    value: 'Campbellsville, KY',
    label: 'Campbellsville, KY'
  },
  {
    value: 'Stillwater, OK',
    label: 'Stillwater, OK'
  },
  {
    value: 'Carbondale-Marion, IL',
    label: 'Carbondale-Marion, IL'
  },
  {
    value: 'Victoria, TX',
    label: 'Victoria, TX'
  },
  {
    value: 'Athens, TN',
    label: 'Athens, TN'
  },
  {
    value: 'Rochester, NY',
    label: 'Rochester, NY'
  },
  {
    value: 'Fernley, NV',
    label: 'Fernley, NV'
  },
  {
    value: 'Gainesville, TX',
    label: 'Gainesville, TX'
  },
  {
    value: 'Fort Madison-Keokuk, IA-IL-MO',
    label: 'Fort Madison-Keokuk, IA-IL-MO'
  },
  {
    value: 'Moultrie, GA',
    label: 'Moultrie, GA'
  },
  {
    value: 'Spokane-Spokane Valley, WA',
    label: 'Spokane-Spokane Valley, WA'
  },
  {
    value: 'Fort Collins, CO',
    label: 'Fort Collins, CO'
  },
  {
    value: 'Pittsfield, MA',
    label: 'Pittsfield, MA'
  },
  {
    value: 'Greeneville, TN',
    label: 'Greeneville, TN'
  },
  {
    value: 'Toccoa, GA',
    label: 'Toccoa, GA'
  },
  {
    value: 'Forest City, NC',
    label: 'Forest City, NC'
  },
  {
    value: 'Panama City, FL',
    label: 'Panama City, FL'
  },
  {
    value: 'Cullowhee, NC',
    label: 'Cullowhee, NC'
  },
  {
    value: 'Jamestown-Dunkirk-Fredonia, NY',
    label: 'Jamestown-Dunkirk-Fredonia, NY'
  },
  {
    value: 'Bellingham, WA',
    label: 'Bellingham, WA'
  },
  {
    value: 'Farmington, NM',
    label: 'Farmington, NM'
  },
  {
    value: 'Middlesborough, KY',
    label: 'Middlesborough, KY'
  },
  {
    value: 'Washington, IN',
    label: 'Washington, IN'
  },
  {
    value: 'Lake City, FL',
    label: 'Lake City, FL'
  },
  {
    value: 'Safford, AZ',
    label: 'Safford, AZ'
  },
  {
    value: 'Valdosta, GA',
    label: 'Valdosta, GA'
  },
  {
    value: 'Yuba City, CA',
    label: 'Yuba City, CA'
  },
  {
    value: 'Rocky Mount, NC',
    label: 'Rocky Mount, NC'
  },
  {
    value: 'Cleveland, TN',
    label: 'Cleveland, TN'
  },
  {
    value: 'Oak Harbor, WA',
    label: 'Oak Harbor, WA'
  },
  {
    value: 'Selinsgrove, PA',
    label: 'Selinsgrove, PA'
  },
  {
    value: 'Bluefield, WV-VA',
    label: 'Bluefield, WV-VA'
  },
  {
    value: 'Ponca City, OK',
    label: 'Ponca City, OK'
  },
  {
    value: 'Madison, WI',
    label: 'Madison, WI'
  },
  {
    value: 'East Stroudsburg, PA',
    label: 'East Stroudsburg, PA'
  },
  {
    value: 'Oklahoma City, OK',
    label: 'Oklahoma City, OK'
  },
  {
    value: 'Roseburg, OR',
    label: 'Roseburg, OR'
  },
  {
    value: 'Williamsport, PA',
    label: 'Williamsport, PA'
  },
  {
    value: 'Williston, ND',
    label: 'Williston, ND'
  },
  {
    value: 'Rapid City, SD',
    label: 'Rapid City, SD'
  },
  {
    value: 'Gallup, NM',
    label: 'Gallup, NM'
  },
  {
    value: 'Burlington, IA-IL',
    label: 'Burlington, IA-IL'
  },
  {
    value: 'Altus, OK',
    label: 'Altus, OK'
  },
  {
    value: 'Newport, OR',
    label: 'Newport, OR'
  },
  {
    value: 'Tyler, TX',
    label: 'Tyler, TX'
  },
  {
    value: 'Reno, NV',
    label: 'Reno, NV'
  },
  {
    value: 'Manchester-Nashua, NH',
    label: 'Manchester-Nashua, NH'
  },
  {
    value: 'California-Lexington Park, MD',
    label: 'California-Lexington Park, MD'
  },
  {
    value: 'Kill Devil Hills, NC',
    label: 'Kill Devil Hills, NC'
  },
  {
    value: 'Utica-Rome, NY',
    label: 'Utica-Rome, NY'
  },
  {
    value: "Coeur d'Alene, ID",
    label: "Coeur d'Alene, ID"
  },
  {
    value: 'Bogalusa, LA',
    label: 'Bogalusa, LA'
  },
  {
    value: 'Duluth, MN-WI',
    label: 'Duluth, MN-WI'
  },
  {
    value: 'Wilmington, NC',
    label: 'Wilmington, NC'
  },
  {
    value: 'Danville, KY',
    label: 'Danville, KY'
  },
  {
    value: 'Vineland-Bridgeton, NJ',
    label: 'Vineland-Bridgeton, NJ'
  },
  {
    value: 'Anniston-Oxford-Jacksonville, AL',
    label: 'Anniston-Oxford-Jacksonville, AL'
  },
  {
    value: 'Fremont, NE',
    label: 'Fremont, NE'
  },
  {
    value: 'Gadsden, AL',
    label: 'Gadsden, AL'
  },
  {
    value: 'Marietta, OH',
    label: 'Marietta, OH'
  },
  {
    value: 'Clarksville, TN-KY',
    label: 'Clarksville, TN-KY'
  },
  {
    value: 'Myrtle Beach-Conway-North Myrtle Beach, SC-NC',
    label: 'Myrtle Beach-Conway-North Myrtle Beach, SC-NC'
  },
  {
    value: 'Rio Grande City, TX',
    label: 'Rio Grande City, TX'
  },
  {
    value: 'Elko, NV',
    label: 'Elko, NV'
  },
  {
    value: 'Houma-Thibodaux, LA',
    label: 'Houma-Thibodaux, LA'
  },
  {
    value: 'Lewisburg, TN',
    label: 'Lewisburg, TN'
  },
  {
    value: 'Fairbanks, AK',
    label: 'Fairbanks, AK'
  },
  {
    value: 'Shreveport-Bossier City, LA',
    label: 'Shreveport-Bossier City, LA'
  },
  {
    value: 'York-Hanover, PA',
    label: 'York-Hanover, PA'
  },
  {
    value: 'Buffalo-Cheektowaga-Niagara Falls, NY',
    label: 'Buffalo-Cheektowaga-Niagara Falls, NY'
  },
  {
    value: 'St. George, UT',
    label: 'St. George, UT'
  },
  {
    value: 'Bakersfield, CA',
    label: 'Bakersfield, CA'
  },
  {
    value: 'Allentown-Bethlehem-Easton, PA-NJ',
    label: 'Allentown-Bethlehem-Easton, PA-NJ'
  },
  {
    value: 'Cape Coral-Fort Myers, FL',
    label: 'Cape Coral-Fort Myers, FL'
  },
  {
    value: 'Fort Polk South, LA',
    label: 'Fort Polk South, LA'
  },
  {
    value: 'Sumter, SC',
    label: 'Sumter, SC'
  },
  {
    value: 'Tullahoma-Manchester, TN',
    label: 'Tullahoma-Manchester, TN'
  },
  {
    value: 'Monroe, LA',
    label: 'Monroe, LA'
  },
  {
    value: 'Vernon, TX',
    label: 'Vernon, TX'
  },
  {
    value: 'Heber, UT',
    label: 'Heber, UT'
  },
  {
    value: 'Hilo, HI',
    label: 'Hilo, HI'
  },
  {
    value: 'Houghton, MI',
    label: 'Houghton, MI'
  },
  {
    value: 'Clearlake, CA',
    label: 'Clearlake, CA'
  },
  {
    value: 'Bastrop, LA',
    label: 'Bastrop, LA'
  },
  {
    value: 'Dover, DE',
    label: 'Dover, DE'
  },
  {
    value: 'Visalia-Porterville, CA',
    label: 'Visalia-Porterville, CA'
  },
  {
    value: 'Modesto, CA',
    label: 'Modesto, CA'
  },
  {
    value: 'Provo-Orem, UT',
    label: 'Provo-Orem, UT'
  },
  {
    value: 'Erie, PA',
    label: 'Erie, PA'
  },
  {
    value: 'Key West, FL',
    label: 'Key West, FL'
  },
  {
    value: 'St. Cloud, MN',
    label: 'St. Cloud, MN'
  },
  {
    value: 'Gulfport-Biloxi-Pascagoula, MS',
    label: 'Gulfport-Biloxi-Pascagoula, MS'
  },
  {
    value: 'Oneonta, NY',
    label: 'Oneonta, NY'
  },
  {
    value: 'Newport, TN',
    label: 'Newport, TN'
  },
  {
    value: 'McAlester, OK',
    label: 'McAlester, OK'
  },
  {
    value: 'Madera, CA',
    label: 'Madera, CA'
  },
  {
    value: 'Kennewick-Richland, WA',
    label: 'Kennewick-Richland, WA'
  },
  {
    value: 'Danville, IL',
    label: 'Danville, IL'
  },
  {
    value: 'Washington, NC',
    label: 'Washington, NC'
  },
  {
    value: 'Union City, TN-KY',
    label: 'Union City, TN-KY'
  },
  {
    value: 'Greenville, NC',
    label: 'Greenville, NC'
  },
  {
    value: 'Bend-Redmond, OR',
    label: 'Bend-Redmond, OR'
  },
  {
    value: 'Jacksonville, TX',
    label: 'Jacksonville, TX'
  },
  {
    value: 'Bridgeport-Stamford-Norwalk, CT',
    label: 'Bridgeport-Stamford-Norwalk, CT'
  },
  {
    value: 'Stockton-Lodi, CA',
    label: 'Stockton-Lodi, CA'
  },
  {
    value: 'Searcy, AR',
    label: 'Searcy, AR'
  },
  {
    value: 'Merced, CA',
    label: 'Merced, CA'
  },
  {
    value: 'Elkins, WV',
    label: 'Elkins, WV'
  },
  {
    value: 'Naples-Immokalee-Marco Island, FL',
    label: 'Naples-Immokalee-Marco Island, FL'
  },
  {
    value: 'Española, NM',
    label: 'Española, NM'
  },
  {
    value: 'Aberdeen, WA',
    label: 'Aberdeen, WA'
  },
  {
    value: 'Grand Forks, ND-MN',
    label: 'Grand Forks, ND-MN'
  },
  {
    value: 'Morehead City, NC',
    label: 'Morehead City, NC'
  },
  {
    value: 'Bay City, TX',
    label: 'Bay City, TX'
  },
  {
    value: 'Decatur, AL',
    label: 'Decatur, AL'
  },
  {
    value: 'Batavia, NY',
    label: 'Batavia, NY'
  },
  {
    value: 'Watertown-Fort Drum, NY',
    label: 'Watertown-Fort Drum, NY'
  },
  {
    value: 'Florence-Muscle Shoals, AL',
    label: 'Florence-Muscle Shoals, AL'
  },
  {
    value: 'Bennettsville, SC',
    label: 'Bennettsville, SC'
  },
  {
    value: 'Opelousas, LA',
    label: 'Opelousas, LA'
  },
  {
    value: 'Durham-Chapel Hill, NC',
    label: 'Durham-Chapel Hill, NC'
  },
  {
    value: 'Ponce, PR',
    label: 'Ponce, PR'
  },
  {
    value: 'Morristown, TN',
    label: 'Morristown, TN'
  },
  {
    value: 'Lawrenceburg, TN',
    label: 'Lawrenceburg, TN'
  },
  {
    value: 'Aguadilla-Isabela, PR',
    label: 'Aguadilla-Isabela, PR'
  },
  {
    value: 'Winona, MN',
    label: 'Winona, MN'
  },
  {
    value: 'Ukiah, CA',
    label: 'Ukiah, CA'
  },
  {
    value: 'The Villages, FL',
    label: 'The Villages, FL'
  },
  {
    value: 'Harrisonburg, VA',
    label: 'Harrisonburg, VA'
  },
  {
    value: 'Hannibal, MO',
    label: 'Hannibal, MO'
  },
  {
    value: 'Rutland, VT',
    label: 'Rutland, VT'
  },
  {
    value: 'Spirit Lake, IA',
    label: 'Spirit Lake, IA'
  },
  {
    value: 'Malvern, AR',
    label: 'Malvern, AR'
  },
  {
    value: 'Russellville, AR',
    label: 'Russellville, AR'
  },
  {
    value: 'Nacogdoches, TX',
    label: 'Nacogdoches, TX'
  },
  {
    value: 'Mount Sterling, KY',
    label: 'Mount Sterling, KY'
  },
  {
    value: 'Orangeburg, SC',
    label: 'Orangeburg, SC'
  },
  {
    value: 'Elk City, OK',
    label: 'Elk City, OK'
  },
  {
    value: 'Butte-Silver Bow, MT',
    label: 'Butte-Silver Bow, MT'
  },
  {
    value: 'Quincy, IL-MO',
    label: 'Quincy, IL-MO'
  },
  {
    value: 'Bismarck, ND',
    label: 'Bismarck, ND'
  },
  {
    value: 'Bloomington, IL',
    label: 'Bloomington, IL'
  },
  {
    value: 'La Grande, OR',
    label: 'La Grande, OR'
  },
  {
    value: 'Montgomery, AL',
    label: 'Montgomery, AL'
  },
  {
    value: 'Marshall, MO',
    label: 'Marshall, MO'
  },
  {
    value: 'Kapaa, HI',
    label: 'Kapaa, HI'
  },
  {
    value: 'Shawnee, OK',
    label: 'Shawnee, OK'
  },
  {
    value: 'Ashland, OH',
    label: 'Ashland, OH'
  },
  {
    value: 'Vermillion, SD',
    label: 'Vermillion, SD'
  },
  {
    value: 'Chico, CA',
    label: 'Chico, CA'
  },
  {
    value: 'Springfield, IL',
    label: 'Springfield, IL'
  },
  {
    value: 'Las Vegas-Henderson-Paradise, NV',
    label: 'Las Vegas-Henderson-Paradise, NV'
  },
  {
    value: 'Winchester, VA-WV',
    label: 'Winchester, VA-WV'
  },
  {
    value: 'Carson City, NV',
    label: 'Carson City, NV'
  },
  {
    value: 'Jackson, MS',
    label: 'Jackson, MS'
  },
  {
    value: 'Hermiston-Pendleton, OR',
    label: 'Hermiston-Pendleton, OR'
  },
  {
    value: 'London, KY',
    label: 'London, KY'
  },
  {
    value: 'New Haven-Milford, CT',
    label: 'New Haven-Milford, CT'
  },
  {
    value: 'Yankton, SD',
    label: 'Yankton, SD'
  },
  {
    value: 'Seneca, SC',
    label: 'Seneca, SC'
  },
  {
    value: 'New Castle, IN',
    label: 'New Castle, IN'
  },
  {
    value: 'Cumberland, MD-WV',
    label: 'Cumberland, MD-WV'
  },
  {
    value: 'Astoria, OR',
    label: 'Astoria, OR'
  },
  {
    value: 'Klamath Falls, OR',
    label: 'Klamath Falls, OR'
  },
  {
    value: 'Coffeyville, KS',
    label: 'Coffeyville, KS'
  },
  {
    value: 'Sevierville, TN',
    label: 'Sevierville, TN'
  },
  {
    value: 'Syracuse, NY',
    label: 'Syracuse, NY'
  },
  {
    value: 'Batesville, AR',
    label: 'Batesville, AR'
  },
  {
    value: 'Auburn-Opelika, AL',
    label: 'Auburn-Opelika, AL'
  },
  {
    value: 'Sheridan, WY',
    label: 'Sheridan, WY'
  },
  {
    value: 'Eagle Pass, TX',
    label: 'Eagle Pass, TX'
  },
  {
    value: 'Durant, OK',
    label: 'Durant, OK'
  },
  {
    value: 'McAllen-Edinburg-Mission, TX',
    label: 'McAllen-Edinburg-Mission, TX'
  },
  {
    value: 'Rexburg, ID',
    label: 'Rexburg, ID'
  },
  {
    value: 'Fayetteville, NC',
    label: 'Fayetteville, NC'
  },
  {
    value: 'Columbus, OH',
    label: 'Columbus, OH'
  },
  {
    value: 'Price, UT',
    label: 'Price, UT'
  },
  {
    value: 'Gloversville, NY',
    label: 'Gloversville, NY'
  },
  {
    value: 'Eugene, OR',
    label: 'Eugene, OR'
  },
  {
    value: 'Owensboro, KY',
    label: 'Owensboro, KY'
  },
  {
    value: 'Paragould, AR',
    label: 'Paragould, AR'
  },
  {
    value: 'Port Angeles, WA',
    label: 'Port Angeles, WA'
  },
  {
    value: 'Jesup, GA',
    label: 'Jesup, GA'
  },
  {
    value: 'Evansville, IN-KY',
    label: 'Evansville, IN-KY'
  },
  {
    value: 'Salina, KS',
    label: 'Salina, KS'
  },
  {
    value: 'Tuscaloosa, AL',
    label: 'Tuscaloosa, AL'
  },
  {
    value: 'Ellensburg, WA',
    label: 'Ellensburg, WA'
  },
  {
    value: 'New Bern, NC',
    label: 'New Bern, NC'
  },
  {
    value: 'Ogdensburg-Massena, NY',
    label: 'Ogdensburg-Massena, NY'
  },
  {
    value: 'Greensboro-High Point, NC',
    label: 'Greensboro-High Point, NC'
  },
  {
    value: 'Helena-West Helena, AR',
    label: 'Helena-West Helena, AR'
  },
  {
    value: 'Shelbyville, TN',
    label: 'Shelbyville, TN'
  },
  {
    value: 'Paducah, KY-IL',
    label: 'Paducah, KY-IL'
  },
  {
    value: 'Morgantown, WV',
    label: 'Morgantown, WV'
  },
  {
    value: 'Columbia, SC',
    label: 'Columbia, SC'
  },
  {
    value: 'Branson, MO',
    label: 'Branson, MO'
  },
  {
    value: 'Beckley, WV',
    label: 'Beckley, WV'
  },
  {
    value: 'Athens, TX',
    label: 'Athens, TX'
  },
  {
    value: 'Warner Robins, GA',
    label: 'Warner Robins, GA'
  },
  {
    value: 'Edwards, CO',
    label: 'Edwards, CO'
  },
  {
    value: 'Susanville, CA',
    label: 'Susanville, CA'
  },
  {
    value: 'Pocatello, ID',
    label: 'Pocatello, ID'
  },
  {
    value: 'Sterling, IL',
    label: 'Sterling, IL'
  },
  {
    value: 'Trenton, NJ',
    label: 'Trenton, NJ'
  },
  {
    value: 'Moses Lake, WA',
    label: 'Moses Lake, WA'
  },
  {
    value: 'Palm Bay-Melbourne-Titusville, FL',
    label: 'Palm Bay-Melbourne-Titusville, FL'
  },
  {
    value: 'Winnemucca, NV',
    label: 'Winnemucca, NV'
  },
  {
    value: 'Davenport-Moline-Rock Island, IA-IL',
    label: 'Davenport-Moline-Rock Island, IA-IL'
  },
  {
    value: 'Lufkin, TX',
    label: 'Lufkin, TX'
  },
  {
    value: 'Claremont-Lebanon, NH-VT',
    label: 'Claremont-Lebanon, NH-VT'
  },
  {
    value: 'Johnson City, TN',
    label: 'Johnson City, TN'
  },
  {
    value: 'Denver-Aurora-Lakewood, CO',
    label: 'Denver-Aurora-Lakewood, CO'
  },
  {
    value: 'Binghamton, NY',
    label: 'Binghamton, NY'
  },
  {
    value: 'Kennett, MO',
    label: 'Kennett, MO'
  },
  {
    value: 'Salt Lake City, UT',
    label: 'Salt Lake City, UT'
  },
  {
    value: 'Gillette, WY',
    label: 'Gillette, WY'
  },
  {
    value: 'Bangor, ME',
    label: 'Bangor, ME'
  },
  {
    value: 'Bay City, MI',
    label: 'Bay City, MI'
  },
  {
    value: 'Crescent City, CA',
    label: 'Crescent City, CA'
  },
  {
    value: 'Greeley, CO',
    label: 'Greeley, CO'
  },
  {
    value: 'Wisconsin Rapids-Marshfield, WI',
    label: 'Wisconsin Rapids-Marshfield, WI'
  },
  {
    value: 'St. Louis, MO-IL',
    label: 'St. Louis, MO-IL'
  },
  {
    value: 'Martinsville, VA',
    label: 'Martinsville, VA'
  },
  {
    value: 'Oxford, MS',
    label: 'Oxford, MS'
  },
  {
    value: 'Breckenridge, CO',
    label: 'Breckenridge, CO'
  },
  {
    value: 'Valley, AL',
    label: 'Valley, AL'
  },
  {
    value: 'Louisville/Jefferson County, KY-IN',
    label: 'Louisville/Jefferson County, KY-IN'
  },
  {
    value: 'Fayetteville-Springdale-Rogers, AR-MO',
    label: 'Fayetteville-Springdale-Rogers, AR-MO'
  },
  {
    value: 'Ottumwa, IA',
    label: 'Ottumwa, IA'
  },
  {
    value: 'Kirksville, MO',
    label: 'Kirksville, MO'
  },
  {
    value: 'McMinnville, TN',
    label: 'McMinnville, TN'
  },
  {
    value: 'Big Stone Gap, VA',
    label: 'Big Stone Gap, VA'
  },
  {
    value: 'Charleston, WV',
    label: 'Charleston, WV'
  },
  {
    value: 'Hastings, NE',
    label: 'Hastings, NE'
  },
  {
    value: 'Youngstown-Warren-Boardman, OH-PA',
    label: 'Youngstown-Warren-Boardman, OH-PA'
  },
  {
    value: 'Milwaukee-Waukesha-West Allis, WI',
    label: 'Milwaukee-Waukesha-West Allis, WI'
  },
  {
    value: 'Sault Ste. Marie, MI',
    label: 'Sault Ste. Marie, MI'
  },
  {
    value: 'Roanoke Rapids, NC',
    label: 'Roanoke Rapids, NC'
  },
  {
    value: 'Point Pleasant, WV-OH',
    label: 'Point Pleasant, WV-OH'
  },
  {
    value: 'New Ulm, MN',
    label: 'New Ulm, MN'
  },
  {
    value: 'El Centro, CA',
    label: 'El Centro, CA'
  },
  {
    value: 'Kansas City, MO-KS',
    label: 'Kansas City, MO-KS'
  },
  {
    value: 'Columbia, MO',
    label: 'Columbia, MO'
  },
  {
    value: 'Arkansas City-Winfield, KS',
    label: 'Arkansas City-Winfield, KS'
  },
  {
    value: 'Hanford-Corcoran, CA',
    label: 'Hanford-Corcoran, CA'
  },
  {
    value: 'Natchez, MS-LA',
    label: 'Natchez, MS-LA'
  },
  {
    value: 'Corvallis, OR',
    label: 'Corvallis, OR'
  },
  {
    value: 'Rockingham, NC',
    label: 'Rockingham, NC'
  },
  {
    value: 'Waterloo-Cedar Falls, IA',
    label: 'Waterloo-Cedar Falls, IA'
  },
  {
    value: 'Marinette, WI-MI',
    label: 'Marinette, WI-MI'
  },
  {
    value: 'San Juan-Carolina-Caguas, PR',
    label: 'San Juan-Carolina-Caguas, PR'
  },
  {
    value: 'Auburn, NY',
    label: 'Auburn, NY'
  },
  {
    value: 'Grand Junction, CO',
    label: 'Grand Junction, CO'
  },
  {
    value: 'El Dorado, AR',
    label: 'El Dorado, AR'
  },
  {
    value: 'Anchorage, AK',
    label: 'Anchorage, AK'
  },
  {
    value: 'Fargo, ND-MN',
    label: 'Fargo, ND-MN'
  },
  {
    value: 'Terre Haute, IN',
    label: 'Terre Haute, IN'
  },
  {
    value: 'Brenham, TX',
    label: 'Brenham, TX'
  },
  {
    value: 'Los Angeles-Long Beach-Anaheim, CA',
    label: 'Los Angeles-Long Beach-Anaheim, CA'
  },
  {
    value: 'Weirton-Steubenville, WV-OH',
    label: 'Weirton-Steubenville, WV-OH'
  },
  {
    value: 'Janesville-Beloit, WI',
    label: 'Janesville-Beloit, WI'
  },
  {
    value: 'Zapata, TX',
    label: 'Zapata, TX'
  },
  {
    value: 'Laconia, NH',
    label: 'Laconia, NH'
  },
  {
    value: 'Palestine, TX',
    label: 'Palestine, TX'
  },
  {
    value: 'Olympia-Tumwater, WA',
    label: 'Olympia-Tumwater, WA'
  },
  {
    value: 'Picayune, MS',
    label: 'Picayune, MS'
  },
  {
    value: 'Bozeman, MT',
    label: 'Bozeman, MT'
  },
  {
    value: 'Clarksdale, MS',
    label: 'Clarksdale, MS'
  },
  {
    value: 'Napa, CA',
    label: 'Napa, CA'
  },
  {
    value: 'Iron Mountain, MI-WI',
    label: 'Iron Mountain, MI-WI'
  },
  {
    value: 'Blacksburg-Christiansburg-Radford, VA',
    label: 'Blacksburg-Christiansburg-Radford, VA'
  },
  {
    value: 'Bremerton-Silverdale, WA',
    label: 'Bremerton-Silverdale, WA'
  },
  {
    value: 'Del Rio, TX',
    label: 'Del Rio, TX'
  },
  {
    value: 'Durango, CO',
    label: 'Durango, CO'
  },
  {
    value: 'Portland-Vancouver-Hillsboro, OR-WA',
    label: 'Portland-Vancouver-Hillsboro, OR-WA'
  },
  {
    value: 'Lafayette, LA',
    label: 'Lafayette, LA'
  },
  {
    value: 'Vineyard Haven, MA',
    label: 'Vineyard Haven, MA'
  },
  {
    value: 'Santa Cruz-Watsonville, CA',
    label: 'Santa Cruz-Watsonville, CA'
  },
  {
    value: 'Florence, SC',
    label: 'Florence, SC'
  },
  {
    value: 'Juneau, AK',
    label: 'Juneau, AK'
  },
  {
    value: 'Huntsville, AL',
    label: 'Huntsville, AL'
  },
  {
    value: 'Niles-Benton Harbor, MI',
    label: 'Niles-Benton Harbor, MI'
  },
  {
    value: 'Huntingdon, PA',
    label: 'Huntingdon, PA'
  },
  {
    value: 'Brownsville-Harlingen, TX',
    label: 'Brownsville-Harlingen, TX'
  },
  {
    value: 'Lake Charles, LA',
    label: 'Lake Charles, LA'
  },
  {
    value: 'Arkadelphia, AR',
    label: 'Arkadelphia, AR'
  }
]

const unitAmenities = Object.values(UnitAmenity).map((amenity: UnitAmenity) => {
  return {
    value: amenity,
    label: getAmenityTitle(amenity)
  }
})
const unitAmenityTags = Object.values(UnitAmenityTag).map((amenityTag: UnitAmenityTag) => {
  return {
    value: amenityTag,
    label: getAmenityTitle(amenityTag)
  }
})

export const allUnitAmenities: ColumnValueOption[] = [...unitAmenities, ...unitAmenityTags]
export const allBuildingAmenities: ColumnValueOption[] = Object.values(BuildingAmenity).map(
  (amenity: BuildingAmenity) => {
    return {
      value: amenity,
      label: getAmenityTitle(amenity)
    }
  }
)
